<div class="modal-title ui-kit-break-word" translate data-qa="modal-title">
  <ng-content></ng-content>
</div>

<div *ngIf="closable !== false" data-qa-button="close-modal" class="modal-close" (click)="closeModal()"></div>
